"use client";

import { TitleH2 } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { logoFrame } from "../../../../public/images/testimonials";
import TestimonialCarousel from "./TestimonialCarousel";

const Testimonials = () => {
  const t = useTranslations("home");

  return (
    <div className="bg-secondary">
      <div className="m-auto w-full max-w-screen-xl px-6 pt-15 pb-10 sm:px-15">
        <div className="flex flex-col items-center justify-center gap-10 sm:gap-30">
          <TitleH2
            className="text-primary text-center"
            title={t("testimonialTitle")}
          />

          <div className="relative flex w-full max-w-[69.375rem] items-center justify-center">
            <Image
              className="gs--testimonial-background-logo pointer-events-none absolute z-0 hidden opacity-90 sm:block"
              src={logoFrame}
              alt={"logo grundriss schmiede"}
              loading="lazy"
              unoptimized
            />
            <div className="relative z-10 w-full">
              <TestimonialCarousel />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
